import { render, staticRenderFns } from "./SenderRequest.vue?vue&type=template&id=18722e03&"
import script from "./SenderRequest.vue?vue&type=script&lang=js&"
export * from "./SenderRequest.vue?vue&type=script&lang=js&"
import style0 from "./SenderRequest.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports